module.exports = __webpack_public_path__ + "img/ring_r_i_null_0@3x.6fc7fcb6.png";